export const BRAND = {
  logo: "/logo.png",
  mandala:
    "https://static.prod-images.emergentagent.com/jobs/99457374-86f2-4e66-98a6-6c853e4eca55/images/cb7a4ea39725d9f4129ce072aa653dfd170c63955423fead7b0828d13cd7ac8c.png",
  paisley:
    "https://static.prod-images.emergentagent.com/jobs/99457374-86f2-4e66-98a6-6c853e4eca55/images/648ee4d328e6a3792eed4567cd8f80f715126084ff70d4a662be530e89a47ae9.png",
};

export const IMG = {
  heroBride:
    "https://images.pexels.com/photos/36519701/pexels-photo-36519701.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=940",
  brideGold:
    "https://images.unsplash.com/photo-1600685890506-593fdf55949b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  brideSari:
    "https://images.unsplash.com/photo-1610047614301-13c63f00c032?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  brideRedGold:
    "https://images.unsplash.com/photo-1684868268327-7e5590bcfbd6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  brideFloral:
    "https://images.pexels.com/photos/15623001/pexels-photo-15623001.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=940",
  interiorChairs:
    "https://images.unsplash.com/photo-1773904215697-e6c21fc27ac2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  interiorMirror:
    "https://images.pexels.com/photos/10317444/pexels-photo-10317444.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  interiorVanity:
    "https://images.unsplash.com/photo-1764475501545-d5cc9719af1a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  spaMask:
    "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  spaCream:
    "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hairCurl:
    "https://images.unsplash.com/photo-1560869713-7d0a29430803?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hairBlow:
    "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hairStyle:
    "https://images.pexels.com/photos/3993290/pexels-photo-3993290.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  nailsArt:
    "https://images.pexels.com/photos/30294773/pexels-photo-30294773.png?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  nailsRed:
    "https://images.unsplash.com/photo-1590736704728-f4730bb30770?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  {
    id: "hair",
    no: "01",
    name: "Hair & Styling",
    tagline: "Cuts, colour & couture finishes",
    image: IMG.hairCurl,
    desc: "From precision cuts to luminous balayage and bridal hairstyling, our artists sculpt hair into living silk.",
    treatments: [
      ["Signature Cut & Blow-dry", "₹1,800"],
      ["Global / Balayage Colour", "₹4,500"],
      ["Keratin & Smoothening", "₹6,000"],
      ["Bridal Hair Styling", "₹5,500"],
    ],
  },
  {
    id: "skin",
    no: "02",
    name: "Skin & Spa",
    tagline: "Rituals rooted in ayurveda",
    image: IMG.spaMask,
    desc: "Restorative facials and body rituals blending modern science with time-honoured Indian botanicals.",
    treatments: [
      ["Zari Glow Facial", "₹3,200"],
      ["Ubtan Body Ritual", "₹4,800"],
      ["Hydra Radiance Therapy", "₹5,500"],
      ["Aromatherapy Massage", "₹3,800"],
    ],
  },
  {
    id: "bridal",
    no: "03",
    name: "Bridal & Makeup",
    tagline: "Heirloom artistry for your day",
    image: IMG.heroBride,
    desc: "HD & airbrush bridal artistry honouring heritage — every look an heirloom, every bride a queen.",
    treatments: [
      ["Bridal HD Makeup", "₹18,000"],
      ["Engagement / Reception Look", "₹12,000"],
      ["Airbrush Party Makeup", "₹6,500"],
      ["Draping & Adornment", "₹3,000"],
    ],
  },
  {
    id: "nails",
    no: "04",
    name: "Nails & Hands",
    tagline: "Detail down to the fingertips",
    image: IMG.nailsRed,
    desc: "Couture nail art, gel extensions and indulgent hand rituals finished with a regal sheen.",
    treatments: [
      ["Luxe Gel Manicure", "₹1,400"],
      ["Couture Nail Art", "₹2,200"],
      ["Spa Pedicure", "₹1,600"],
      ["Extensions & Overlay", "₹2,800"],
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "They turned my wedding morning into a ceremony of its own. I have never felt more like myself, only luminous.",
    name: "Aarohi Mehta",
    role: "Bride, Udaipur",
  },
  {
    quote:
      "The detail, the calm, the artistry — Zaya & Zari is the only atelier I trust with my skin and my hair.",
    name: "Ishaan Kapoor",
    role: "Regular client",
  },
  {
    quote:
      "It feels like stepping into a palace that somehow also feels like home. Every visit is a small escape.",
    name: "Naina Sharma",
    role: "Member since 2022",
  },
];
